import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["endLeft"];
const NUM_PIECES = 200;
const HZ_DRIFT = 30;
const MIN_DURATION = 2000;
const MAX_DURATION = MIN_DURATION * 1.5;
const COLORS = ['var(--trellis-color-fill-accent-red-default)', 'var(--trellis-color-fill-accent-blue-default)', 'var(--trellis-color-fill-accent-orange-default)'];
const rand = (min, max) => Math.floor(Math.random() * (max - min)) + min;
const initialStyles = i => {
  const width = rand(1, 15);
  const startLeft = Math.round(i * 100 / NUM_PIECES);
  const endLeft = startLeft + Math.round(Math.random() * HZ_DRIFT) - HZ_DRIFT / 2;
  return {
    left: `${startLeft}%`,
    endLeft: `${endLeft}%`,
    background: COLORS[rand(0, COLORS.length)],
    opacity: String(Math.random() + 0.5),
    width: `${width}px`,
    height: `${width * 0.6}px`,
    transitionDuration: `${rand(MIN_DURATION, MAX_DURATION)}ms`,
    transform: `rotate(${rand(-40, 40)}deg)`
  };
};
const createContainer = () => {
  const container = document.createElement('div');
  Object.assign(container.style, {
    position: 'fixed',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: '1112',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0'
  });
  return container;
};
const setStyles = (i, piece) => {
  const _initialStyles = initialStyles(i),
    {
      endLeft
    } = _initialStyles,
    css = _objectWithoutPropertiesLoose(_initialStyles, _excluded);
  Object.keys(css).forEach(name => {
    piece.style[name] = css[name];
  });
  piece.dataset.endLeft = endLeft;
};
const addPiece = (i, container) => {
  const piece = document.createElement('div');
  Object.assign(piece.style, {
    position: 'absolute',
    top: '-10%',
    left: '0',
    transitionProperty: 'top, left',
    transitionTimingFunction: 'linear'
  });
  setStyles(i, piece);
  container.appendChild(piece);
};
const beginAnimation = container => {
  const pieces = [...container.children];
  return pieces.map(piece => setTimeout(() => {
    piece.style.left = piece.dataset.endLeft;
    piece.style.top = '110%';
  }, Math.random() * MAX_DURATION));
};
export const startConfetti = () => {
  const container = createContainer();
  let targetDoc;
  try {
    targetDoc = typeof window !== 'undefined' && window.self !== window.top ? window.top.document : document;
  } catch (_unused) {
    targetDoc = document;
  }
  for (let i = 0; i < NUM_PIECES; i++) {
    addPiece(i, container);
  }
  targetDoc.documentElement.appendChild(container);
  const timeouts = beginAnimation(container);
  const cleanup = () => {
    timeouts.forEach(timeout => clearTimeout(timeout));
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
  };
  timeouts.push(setTimeout(cleanup, MAX_DURATION * 2));
  return cleanup;
};